import { useNavigate } from '@remix-run/react';
import {
  CheckoutData,
  defaultCheckoutData,
} from '~/dataModels/Checkout/Checkout';
//TODO: the error handling of these reponse need to be tested on both methods in this class
const createSessionIfNot = async (basketId: string) => {
  if (basketId === '') {
    console.log(
      'basket id to create session is empty. it should fail to create session.',
    );
    return { success: false, message: 'basketId is empty.' };
  }
  try {
    const session = await fetch('/api/session').then((res) => res.json());

    const checkoutData: CheckoutData = {
      ...defaultCheckoutData,
      basketId: basketId,
    };
    if (session === null) {
      const response = await fetch('/api/session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          actionType: 'create',
          data: checkoutData,
        }),
        credentials: 'include',
      }).then((res) => res.json());
      return { success: response.success };
    } else {
      const checkout: CheckoutData = session;
      if (checkout.basketId !== basketId) {
        const response = await fetch('/api/session', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            actionType: 'create',
            data: checkoutData,
          }),
          credentials: 'include',
        }).then((res) => res.json());
        return { success: response.success };
      } else {
        return { success: true };
      }
    }
  } catch (error) {
    console.error('Error getting checkout data:', error);
    return { success: false };
  }
};
//TODO: since session object is essential for all checkout pages,
// if the update session failed, it should redirect user to shopping-cart page
// add error handling for all use case when this function is called
const updateSession = async (
  navigate: ReturnType<typeof useNavigate>,
  data: Partial<CheckoutData>,
) => {
  try {
    const response = await fetch('/api/session', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        actionType: 'update',
        data: data,
      }),
      credentials: 'include',
    }).then((res) => res.json());
    //TODO: update the response to be handle by client side, not navigate to shopping cart page
    if (response.status === 500 || response.status === 400) {
      //error on handling update, redirect user to shopping cart page
      navigate('/shopping-cart');
    }
    return { success: true };
  } catch (error) {
    console.error('Error updating checkout data:', error);
    return { success: false };
  }
};
export const SessionService = {
  createSessionIfNot: createSessionIfNot,
  updateSession: updateSession,
};
